import { Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
import utc from "dayjs/plugin/utc";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getTotalHours } from "@/api";
import { RootState } from "@/redux/store";

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek)

export const WeeklyTotal: React.FC = () => {
  const { runningTaskStartTime } = useSelector(
    (state: RootState) => state.taskRunnerSlice,
  );
  const { isLoading: isLoadingWeeklyTotalHours, data: totalTimeSavedThisWeek } =
    useQuery({
      queryKey: ["weekly-total"],
      queryFn: async () =>
        await getTotalHours({
          offsetDate: dayjs().startOf("isoWeek").tz().format(),
          limitDate: dayjs().endOf("day").tz().format(),
        }),
    });

  const [todaysTotalTime, setTodaysTotalTime] = useState<string>("00:00:00");
  const { hours, minutes, seconds, milliseconds } = totalTimeSavedThisWeek?.data[0] || {};
  const totalHoursToday = dayjs.duration({
    hours,
    minutes,
    seconds,
    milliseconds,
  });


  useEffect(() => {
    if (
      totalTimeSavedThisWeek?.data?.length &&
      runningTaskStartTime !== "00:00:00"
    ) {
      const interval = setInterval(() => {
        const now = dayjs.utc();
        const start = dayjs.utc(runningTaskStartTime);
        const differenceFromStartTime = dayjs.duration(now.diff(start));

        const combinedDuration = differenceFromStartTime.add(totalHoursToday);

        const totalHours = ((combinedDuration.days() * 24) + combinedDuration.hours())
          .toString()
          .padStart(2, "0");

        const totalMinutes = combinedDuration
          .minutes()
          .toString()
          .padStart(2, "0");

        const totalSeconds = combinedDuration
          .seconds()
          .toString()
          .padStart(2, "0");

        const timeSpent = `${totalHours}:${totalMinutes}:${totalSeconds}`;
        setTodaysTotalTime(timeSpent);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [totalTimeSavedThisWeek?.data?.length, runningTaskStartTime]);

  const defaultBillableTime = [
    hours?.toString().padStart(2, "0") || "00",
    minutes?.toString().padStart(2, "0") || "00",
    seconds?.toString().padStart(2, "0") || "00",
  ].join(":");

  return (
    <Typography variant="h5">
      Weekly Total:{" "}
      {isLoadingWeeklyTotalHours
        ? "00:00:00"
        : todaysTotalTime === "00:00:00"
          ? defaultBillableTime
          : todaysTotalTime}
    </Typography>
  );
};
